/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod/v4';

export const scenarioItemAncestorSchema = z.object({
  depth: z.int(),
  id: z.int(),
  name: z.string(),
});
